import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useSession } from 'store/session';

export const useFetchIdentityVerificationResults = ({
  folder,
  document,
  token,
  team,
  invite,
  enabled,
}) => {
  const client = useClient({
    token: resolveTokenV3(token),
    url: process.env.REACT_APP_API_V3,
  });

  const { team: defaultTeam } = useSession();

  const teamUUID = defaultTeam?.uuid as string;

  const fn = async () => {
    const response = await client.fetchIdentityVerificationResults(
      team ?? teamUUID,
      folder,
      document,
      invite,
    );
    // .then((res) => {
    //   // @ts-ignore
    //   if (res.data.decision && res.data.decision !== 'PASSED') {
    //     throw new Error(`An error occurred: ${res.data.decision}`);
    //   }
    //   return res;
    // })
    // .catch((error) => {
    //   throw error;
    // });
    return response;
  };

  const resolvedToken = resolveTokenV3(token);

  const finalTeam = team ?? teamUUID;

  const query = useQuery(
    ['identity-verification-results', finalTeam, folder, document, resolvedToken],
    fn,
    {
      enabled: Boolean(
        enabled && finalTeam && folder && document && resolvedToken,
      ),
      ...{
        refetchInterval: 5000,
        retry: false,
      },
    },
  );

  return { ...query };
};
